import Chart from 'chart.js';
export default function TileVisibilityChart(chartId, tileLayer) {
  var nbVisibleLabels = [];
  var nbVisibleData = [];
  var nbDisplayedData = [];
  var nbVisibleChart = new Chart(chartId, {
    type: 'bar',
    data: {
      labels: nbVisibleLabels,
      datasets: [{
        label: 'Visible node per level',
        data: nbVisibleData,
        backgroundColor: 'rgba(75, 192, 192, 1)'
      }, {
        label: 'Diplayed node per level',
        data: nbDisplayedData,
        backgroundColor: 'rgba(153, 102, 255, 1)'
      }]
    },
    options: {
      scales: {
        yAxes: [{
          display: true,
          ticks: {
            suggestedMin: 0 // minimum will be 0, unless there is a lower value.

          }
        }]
      }
    }
  });

  this.update = function (displayed) {
    function countVisible(node, stats) {
      if (!node || !node.visible) {
        return;
      }

      if (node.level >= 0 && node.layer === tileLayer) {
        if (stats[node.level]) {
          stats[node.level][0] += 1;
        } else {
          stats[node.level] = [1, 0];
        }

        if (node.material.visible) {
          stats[node.level][1] += 1;
        }
      }

      if (node.children) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = node.children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var child = _step.value;
            countVisible(child, stats);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
              _iterator["return"]();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    } // update bar graph


    var stats = {};
    countVisible(tileLayer.object3d, stats);
    nbVisibleLabels.length = 0;
    nbVisibleData.length = 0;

    for (var level in stats) {
      if ({}.hasOwnProperty.call(stats, level)) {
        nbVisibleLabels[level] = "".concat(level);
        nbVisibleData[level] = stats[level][0];
        nbDisplayedData[level] = stats[level][1];
      }
    }

    if (displayed) {
      nbVisibleChart.update();
    }
  };

  this.resize = function () {
    nbVisibleChart.resize();
  };
}